import { render, staticRenderFns } from "./GoodsConfigList.vue?vue&type=template&id=e2a5ef3a"
import script from "./GoodsConfigList.vue?vue&type=script&lang=js"
export * from "./GoodsConfigList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports